var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrowGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9.51859C17.25 8.71534 16.752 8.06417 16.1377 8.06417H3.93811L8.45976 2.55191C8.76682 2.20274 8.90355 1.66218 8.81626 1.14247C8.72896 0.622757 8.43158 0.20686 8.04087 0.0580621C7.65016 -0.0907356 7.22849 0.0513203 6.94142 0.428457L0.353601 8.45323C0.128062 8.72831 0 9.11349 0 9.51678C0 9.92006 0.128062 10.3052 0.353601 10.5803L6.94142 18.6087C7.39064 19.157 8.09471 19.1252 8.51398 18.5378C8.93326 17.9504 8.90898 17.0299 8.45976 16.4816L3.93811 10.973H16.1377C16.752 10.973 17.25 10.3218 17.25 9.51859Z",
    fill: "#727E8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowGray);
export default __webpack_public_path__ + "static/media/back-arrow-gray.85c833b8.svg";
export { ForwardRef as ReactComponent };